module.exports = {
  400: 'S\'il vous plaît remplir tous les champs obligatoires.',
  404: 'Vous n\'êtes pas autorisé pour cette action.',
  401: 'L\'action demandée n\'a pas été retrouvée.',
  acceptTerms: 'Vous devez accepter nos conditions générales.',
  emailNotFound: 'Votre adresse e-mail n\'a pas été retrouvée.',
  fillAllFields: 'Veuillez remplir tous les champs obligatoires.',
  general: 'Quelque chose s\'est mal passé. Veuillez réessayer plus tard.',
  invalidCredentials: 'Votre adresse e-mail et votre mot de passe ne correspondent pas à nos données.',
  invalidPassword: 'Votre mot de passe actuel ne correspond pas à nos données.',
  maintenance: {
    description: 'Ce service n\'est actuellement pas disponible. Veuillez réessayer plus tard.',
    title: 'Maintenance',
  },
  page: {
    description: 'Oups! Quelque chose s\'est mal passé. Nous n\'avons pas pu trouver la page demandée.',
    title: 'Page non trouvée',
  },
  validation: {
    email: 'Ceci n\'est pas un e-mail valide.',
    min: {
      string: 'Ceci doit compter au moins 6 caractères.',
    },
    required: 'Ce champ est obligatoire.',
  },
  systemDefinition: {
    lessControllersThanCircuits: 'There are less controllers than circuits',
  },
};



// WEBPACK FOOTER //
// ./js/lang/fr/errors.js